import { useState, useRef } from "react";
import { F, P } from "../../styles/palette";
import usePatientProfile from "../../hooks/usePatientProfile";
import PHome from "./PHome";
import PEdu from "./PEdu";
import PSelfCare from "./PSelfCare";
import PEmotional from "./PEmotional";
import PExercise from "./PExercise";
import PSurgery from "./PSurgery";
import PStages from "./PStages";
import PFAQ from "./PFAQ";
import PAlarm from "./PAlarm";
import PQOL from "./PQOL";
import PBlog from "./PBlog";
import PBlogPost from "./PBlogPost";
import PHistory from "./PHistory";
import PPhotos from "./PPhotos";

export default function PatientPortal({ user }) {
  const [pg, setPg] = useState("home");
  const ref = useRef(null);
  const nav = p => { setPg(p); ref.current?.scrollTo(0, 0); };

  // Vincular cuenta del paciente con su expediente médico
  const { patient, patientId } = usePatientProfile(user);

  const renderPage = () => {
    if (pg.startsWith("blogpost_")) return <PBlogPost nav={nav} postId={pg.replace("blogpost_", "")} />;
    const pages = {
      home: <PHome nav={nav} />,
      edu: <PEdu nav={nav} />,
      selfcare: <PSelfCare nav={nav} />,
      emotional: <PEmotional nav={nav} />,
      exercise: <PExercise nav={nav} />,
      surgery: <PSurgery nav={nav} />,
      stages: <PStages nav={nav} />,
      faq: <PFAQ nav={nav} />,
      alarm: <PAlarm nav={nav} />,
      qol: <PQOL nav={nav} patientId={patientId} />,
      blog: <PBlog nav={nav} />,
      // Nuevas tabs conectadas a Firestore (solo si hay expediente vinculado)
      history: <PHistory nav={nav} patientId={patientId} />,
      miphotos: <PPhotos nav={nav} patientId={patientId} />,
    };
    return pages[pg] || pages.home;
  };

  return (
    <div ref={ref} style={{ minHeight: "100vh", background: P.bg, fontFamily: F.b, overflowY: "auto" }}>
      {/* Banner de vinculación — solo si el expediente aún no está enlazado */}
      {user?.role === "patient" && !patientId && (
        <div style={{ background: "#fef9c3", borderBottom: "1px solid #fde68a", padding: "10px 20px", textAlign: "center" }}>
          <p style={{ margin: 0, fontSize: 12, color: "#92400e" }}>
            Su cuenta aún no está vinculada a un expediente médico. Las secciones "Mi Historia" y "Mis Fotos" estarán disponibles luego de que su médico lo registre.
          </p>
        </div>
      )}

      {/* Accesos directos a secciones clínicas (si tiene expediente) */}
      {patientId && (
        <div style={{ background: P.acL, borderBottom: `1px solid ${P.bdr}`, padding: "10px 20px", display: "flex", gap: 10, justifyContent: "center", flexWrap: "wrap" }}>
          <button onClick={() => nav("history")}
            style={{ padding: "7px 16px", borderRadius: 20, border: `1px solid ${P.ac}`, background: pg === "history" ? P.ac : "transparent", color: pg === "history" ? "#fff" : P.ac, fontSize: 12, fontWeight: 600, cursor: "pointer", fontFamily: F.b }}>
            📋 Mi Historia
          </button>
          <button onClick={() => nav("miphotos")}
            style={{ padding: "7px 16px", borderRadius: 20, border: `1px solid ${P.ac}`, background: pg === "miphotos" ? P.ac : "transparent", color: pg === "miphotos" ? "#fff" : P.ac, fontSize: 12, fontWeight: 600, cursor: "pointer", fontFamily: F.b }}>
            📷 Mis Fotos
          </button>
          <button onClick={() => nav("qol")}
            style={{ padding: "7px 16px", borderRadius: 20, border: `1px solid ${P.ac}`, background: pg === "qol" ? P.ac : "transparent", color: pg === "qol" ? "#fff" : P.ac, fontSize: 12, fontWeight: 600, cursor: "pointer", fontFamily: F.b }}>
            📊 Calidad de Vida
          </button>
        </div>
      )}

      <div style={{ maxWidth: 820, margin: "0 auto", padding: "30px 26px 56px" }}>
        {renderPage()}
      </div>
    </div>
  );
}
